import { useQuery } from "@tanstack/react-query";
import deliveryCore from "../core/delivery.core";

export default function useDeliveryVehichles() {
  return useQuery({
    queryKey: ["deliveryVehicles"],
    queryFn: () => deliveryCore.listVehicles(),
  });
}
